import React, { useEffect, useRef, useState } from "react";
import styles from "./NewsDetails.module.css";
import { useDispatch, useSelector } from "react-redux";
import { newsDetailsData } from "../../features/newsDetails/newsDetailsSlice";
import { newsData } from "../../features/news/newSlice";
import { Link, useParams } from "react-router-dom";

const NewsDetails = () => {
  const { news_id } = useParams();
  const dispatch = useDispatch();
  const dataNews = useSelector((state) => state.news.data);
  const pendingNews = useSelector((state) => state.news.pending);
  const errorNews = useSelector((state) => state.news.error);
  const finalDataNews = dataNews.data;

  const dataNewsDetails = useSelector((state) => state.newsDetails.data);
  const pendingNewsDetails = useSelector((state) => state.newsDetails.pending);
  const errorNewsDetails = useSelector((state) => state.newsDetails.error);
  const finalDataNewsDetails = dataNewsDetails.data;
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const removeQuotes = (string) => {
    const cleanedText = string.replace(/['"]/g, "");
    return cleanedText;
  };

  useEffect(() => {
    dispatch(newsData());
    if (news_id) {
      dispatch(newsDetailsData(news_id));
    } else {
      dispatch(newsDetailsData(finalDataNews?.[0]?.news_id));
    }

    if (pendingNews || pendingNewsDetails) {
      return <div>Loading...</div>;
    }
    if (errorNews || errorNewsDetails) {
      return <div>Error: {errorNews}</div>;
    }

    if (!dataNewsDetails || !dataNews) {
      return <div>Something Went Wrong</div>;
    }
  }, [dispatch, news_id]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.newsDetailsWrapper}>
      <div
        className={screenWidth >= 768 ? styles.leftContainer : styles.inactive}
      >
        <h3>Latest News</h3>
        <div className={styles.latestNewsContainer}>
          {finalDataNews?.map((item, index) => {
            if (index % 2 !== 0) {
              return (
                <Link to={`/news/${item.news_id}`} key={index}>
                  <div className={styles.slide}>
                    <div className={styles.newsData}>
                      <div className={styles.firstContainer}>
                        <img
                          src={`https://images.weserv.nl/?url=${item.image}`}
                          alt=""
                          className={styles.newsImage}
                        />
                      </div>
                      <div className={styles.secondContainer}>
                        <p className={styles.newsDate}>{item.pub_date}</p>
                      </div>
                      <div className={styles.thirdContainer}>
                        <p>{item.title}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            }
          })}
        </div>
      </div>

      <div className={styles.middleContainer}>
        <h3>Detailed News</h3>
        <div className={styles.detailedNewsContainer}>
          <img
            src={`https://images.weserv.nl/?url=${dataNewsDetails?.image}`}
            alt=""
          />
          <div className={styles.secondContainer}>
            <p className={styles.newsDate}>{dataNewsDetails?.pub_date}</p>
          </div>
          <div className={styles.newsTitle}>{dataNewsDetails?.title}</div>
          <div>
            {dataNewsDetails?.content?.map((item) => (
              <div
                dangerouslySetInnerHTML={{ __html: removeQuotes(item) }}
                className={styles.newsText}
              ></div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.rightContainer}>
        <h3>Related News</h3>
        <div className={styles.relatedNewsContainer}>
          {finalDataNews?.map((item, index) => {
            if (index % 2 === 0) {
              return (
                <Link to={`/news/${item.news_id}`} key={index}>
                  <div className={styles.slide}>
                    <div className={styles.newsData}>
                      <div className={styles.firstContainer}>
                        <img
                          src={`https://images.weserv.nl/?url=${item.image}`}
                          alt=""
                          className={styles.newsImage}
                        />
                      </div>
                      <div className={styles.secondContainer}>
                        <p className={styles.newsDate}>{item.pub_date}</p>
                      </div>
                      <div className={styles.thirdContainer}>
                        <p>{item.title}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default NewsDetails;
